import { fetchProjects as fetchSupabaseProjects } from './supabase';
import { generateSlug } from './utils';
import { projects as mockProjects } from '../data/mock';

export const loadAllProjects = async () => {
  try {
    const supabaseData = await fetchSupabaseProjects();
    
    const supabaseProjects = supabaseData && supabaseData.length > 0 
      ? supabaseData
          .filter(project => project.visible !== false)
          .map(project => {
            const isImageUrl = (url) => {
              if (!url) return false;
              const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.svg'];
              return imageExtensions.some(ext => url.toLowerCase().includes(ext));
            };
            
            let imageUrl = null;
            let demoUrl = null;
            
            if (isImageUrl(project.homepage)) {
              imageUrl = project.homepage;
              demoUrl = null; 
            } else {
              demoUrl = project.homepage;
              if (project.html_url) {
                const repoPath = project.html_url.replace('https://github.com/', '');    
                imageUrl = `https://raw.githubusercontent.com/${repoPath}/main/docs/images/Homepage.png`;
              }
            }
            
            if (!imageUrl) {
              const placeholders = [
                'https://images.unsplash.com/photo-1551288049-bebda4e38f71',
                'https://images.unsplash.com/photo-1558494949-ef010cbdcc31',
                'https://images.unsplash.com/photo-1460925895917-afdab827c52f'
              ];
              const randomIndex = Math.floor(Math.random() * placeholders.length);
              imageUrl = `${placeholders[randomIndex]}?w=800&h=500&fit=crop`;
            }
            
            const title = project.name.replace(/-/g, ' ').replace(/_/g, ' ');
            return {
              id: `supabase-${project.id}`,
              title: title,
              slug: generateSlug(title),
              category: project.category || 'fullstack',
              description: project.custom_description || project.description || 'No description available',
              technologies: project.technologies || [project.language].filter(Boolean),
              image: imageUrl,
              github: project.html_url,
              demo: demoUrl || project.demo_url,
              featured: project.featured || false,
              createdAt: project.created_at,
              source: 'supabase'
            };
          })
      : [];

    const manualProjects = mockProjects.map(project => ({
      ...project,
      id: `manual-${project.id}`,
      slug: generateSlug(project.title),
      source: 'manual'
    }));
    
    return [...manualProjects, ...supabaseProjects];
  } catch (error) {
    console.error('Error in loadAllProjects:', error);
    return mockProjects.map(project => ({
      ...project,
      id: `manual-${project.id}`,
      slug: generateSlug(project.title),
      source: 'manual'
    }));
  }
};
